import React, {Component} from 'react';
import './home_page_mobile_button.scss';
import {Link} from "react-router-dom";
import isExternal from 'is-url-external';

class LuissButton7 extends Component {
    render() {

        let button = (
            <>
            <button className="luiss-button7-mob" >
                <div>{this.props.children}</div>
            </button>
            <div className="luiss-button7-background-mob" />
            </>
        );

        if(isExternal(this.props.url)) {
            // external link
            return (
                <a href={this.props.url} id="luiss-button7-link-mob">
                    {button}
                </a>
            );

        } else if (this.props.url) {
            // internal link
            return (
                <Link to={this.props.url} id="luiss-button7-link-mob">
                    {button}
                </Link>
            );

        } else {
            return (
                <div onClick={() => this.props.action()} id="luiss-button7-link-mob">
                    {button}
                </div>
            );
        }
    }
}

export default LuissButton7;
